import { Table, styled } from "@mui/material";

export const AnalyticTableContainer = styled(Table)(() => ({
  border: `1px solid rgba(224, 224, 224, 1)`,
  borderRadius: "5px",
  marginBottom: "25px",
}));
